function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Login-1{fill:#37beb7;stroke:#37beb7;}.Login-1,.Login-2{stroke-miterlimit:10;}.Login-2{fill:#16224a;stroke:#16224a;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "Login-1",
  d: "M344.63,432.39a19.12,19.12,0,0,0,27,27l131.94-132a22.08,22.08,0,0,0,0-29L371.67,166.57a19.12,19.12,0,1,0-27,27L444.9,293.88H32.07a19.13,19.13,0,1,0,0,38.25H444.9Z",
  transform: "translate(0.5 -37.75)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "Login-2",
  d: "M331.68,425.38a19.12,19.12,0,0,0,27.05,27l131.94-132a22.08,22.08,0,0,0,0-29L358.73,159.56a19.12,19.12,0,0,0-27.05,27L432,286.87H19.12a19.13,19.13,0,0,0,0,38.25H432ZM535.5,38.25H153a76.5,76.5,0,0,0-76.5,76.5v76.5h38.25v-76.5A38.26,38.26,0,0,1,153,76.5H535.5a38.26,38.26,0,0,1,38.25,38.25v382.5A38.26,38.26,0,0,1,535.5,535.5H153a38.24,38.24,0,0,1-38.25-38.25v-76.5H76.5v76.5a76.5,76.5,0,0,0,76.5,76.5H535.5a76.5,76.5,0,0,0,76.5-76.5V114.75A76.5,76.5,0,0,0,535.5,38.25Z",
  transform: "translate(0.5 -37.75)"
});

var SvgLogin = function SvgLogin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "login",
    viewBox: "0 0 613 536.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Login.f80f34fa.svg";
export { ForwardRef as ReactComponent };